export default __webpack_public_path__ + "static/media/growing-plant.f8189dae.gif";